import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import MeasurementUnitActions from "./components/MeasurementUnitActions/MeasurementUnitActions";
import MeasurementUnitTable from "./components/MeasurementUnitTable/MeasurementUnitTable";

const MeasurementUnitWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: "Quản lý Đơn vị tính", href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <MeasurementUnitActions handleSearch={handleSearch} params={params} />
          <MeasurementUnitTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default MeasurementUnitWebLayout;
